//////////////////
////////////////////////////////////////
/////////

// TODO fix or remove, now it's never used
let instascan_shared = null;

export
async function importInstascan() {
    if (!instascan_shared) {
//////////////////////////
///////////////////////////////////////
////////////////
        instascan_shared = await import(/* webpackChunkName: "instascan" */ '@cadwork/instascan');
/////////////////
    }

    return instascan_shared;
}

export async function importWatterImage() {
    return import(/* webpackChunkName: "waterImage" */ '@assets/images/water.svg');
}

export async function importHouseImage() {
    return import(/* webpackChunkName: "houseImage" */ '@assets/images/house.svg');
}

export async function importMountainsImage() {
    return import(/* webpackChunkName: "mountainsImage" */ '@assets/images/mountains.svg');
}
